import './CandidateTable.css';
import RenderAvatar from './RenderAvatar';
import LinkButton from './LinkButton';
import ConnectionButtons from './ConnectionButtons';

const CandidateTable = ({ candidates, onCandidateClick, isAdmin = false, onLevelUpdate }) => {
  const validateLevelInput = (value) => {
    // Allow empty string for clearing input
    if (value === '') return true;
    
    // Check if it's a valid number
    const num = parseInt(value);
    if (isNaN(num)) return false;
    
    // Check range
    return num >= 0 && num <= 100000;
  };

  const handleLevelInputChange = (slug, value) => {
    if (validateLevelInput(value)) {
      onLevelUpdate(slug, value);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
  };

  const getLinkedInUrl = (linkedin) => {
    if (!linkedin) return null;
    if (linkedin.startsWith('http')) return linkedin;
    return `https://linkedin.com/in/${linkedin}`;
  };

  const getCofounderMatchUrl = (slug) => {
    return `https://www.startupschool.org/cofounder-matching/candidate/${slug}`;
  };

  if (!candidates || candidates.length === 0) {
    return (
      <div className="no-candidates">
        <p>No candidates found matching your criteria.</p>
      </div>
    );
  }

  return (
    <div className="candidate-table-container">
      <table className="candidate-table">
        <tbody>
          {candidates.map(candidate => (
            <tr 
              key={candidate.slug} 
              className="candidate-row"
              onClick={() => onCandidateClick(candidate)}
            >
              <td className="avatar-cell">
                <div className="candidate-avatar">
                  <RenderAvatar candidate={candidate}/>
                </div>
              </td>
              
              <td className="name-cell">
                <div className="candidate-name">
                  <span className="name">{candidate.name}</span>
                </div>
              </td>
              
              <td className="age-cell">
                {candidate.age || 'N/A'}
              </td>
              
              <td className="technical-cell">
                {candidate.isTechnical !== null ? (
                  <span className={`technical-badge ${candidate.isTechnical ? 'technical' : 'non-technical'}`}>
                    {candidate.isTechnical ? 'Technical' : 'None'}
                  </span>
                ) : 'N/A'}
              </td>
              
              <td className="location-cell">
                <div className="location-info">
                  {candidate.location && <span className="location">{candidate.location}<span className='location-comma'>,</span></span>}
                  {candidate.location && <span className="location-region">{candidate.region}</span>}
                </div>
              </td>
              
              <td className="last-seen-cell">
                {formatDate(candidate.lastSeenAt)}
              </td>
              
              <td className="linkedin-cell">
                <LinkButton url={getLinkedInUrl(candidate.linkedin)} name={'LinkedIn'} className={'linkedin-btn'} />
              </td>
              
              <td className="profile-cell">
                <LinkButton url={getCofounderMatchUrl(candidate.slug)} name={'YC'} className={'profile-btn'} />
              </td>
              
              <td className="level-cell">
                {isAdmin ? (
                  <input
                    type="number"
                    min="0"
                    max="100000"
                    value={candidate.level || 0}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleLevelInputChange(candidate.slug, e.target.value);
                    }}
                    className="level-input"
                    onClick={(e) => e.stopPropagation()}
                  />
                ) : (
                  <span className="level-display">{candidate.level || 0}</span>
                )}
              </td>

              <td className="connection-cell">
                <ConnectionButtons candidateSlug={candidate.slug} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CandidateTable;